import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useState } from "react";
import { httpClient } from "../services/http/httpClient";
import { HoverOverlay, FormatTooltip } from "../general";
import { Loader } from "../index";
import { mapKeysToDisplayNames } from "./utils";
function Relationship(props) {
    const { attribute, data, detail, baseUrl, entityMeta } = props;
    const [contents, setContents] = useState(_jsx(Loader, { size: "sm" }));
    const endpoint = "/" + data["type"] + "/" + data["id"];
    const loadRelationship = () => {
        httpClient()
            .get(endpoint, {
            baseURL: baseUrl,
        })
            .then((res) => {
            // error if endpoint doesn't return 200
            if (res.status !== 200) {
                throw Error();
            }
            const apiData = res.data.data;
            const contentsToDisplay = mapKeysToDisplayNames(apiData["attributes"], entityMeta.flatAttributes[data["type"]]);
            setContents(_jsx(FormatTooltip, { contents: contentsToDisplay }));
        })
            .catch((error) => {
            setContents("Object cannot be found: " + error.message);
        });
    };
    if (data["id"] === null || data["id"] === "")
        return _jsx(_Fragment, {});
    const box = (_jsx(HoverOverlay, { placement: "auto", contents: contents, onHover: () => loadRelationship(), delay: 250, children: _jsx("div", { className: "link-box", children: data["attributes"][attribute] }) }));
    if (detail) {
        return _jsx("a", { href: endpoint, children: box });
    }
    return box;
}
export default Relationship;
